// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wh8y_pvS62QoOHaMXiUt{flex-direction:column;justify-content:center;align-items:center;height:100%;display:flex}.Wh8y_pvS62QoOHaMXiUt .ndffug8gshEv1RunuWMq{background:var(--red-10);border-radius:100px;justify-content:center;align-items:center;width:80px;height:80px;display:flex}.Wh8y_pvS62QoOHaMXiUt .ndffug8gshEv1RunuWMq .fh4k7_KgoPIiqdtoOE_l{background:var(--red-60);border-radius:12px;width:32px;height:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Wh8y_pvS62QoOHaMXiUt`,
	"iconWrap": `ndffug8gshEv1RunuWMq`,
	"icon": `fh4k7_KgoPIiqdtoOE_l`
};
export default ___CSS_LOADER_EXPORT___;
